var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FF5252"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22C19.3373 22 18.8 21.4627 18.8 20.8V12.8C18.8 12.1373 19.3373 11.6 20 11.6C20.6627 11.6 21.2 12.1373 21.2 12.8V20.8C21.2 21.4627 20.6627 22 20 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24.8C19.1163 24.8 18.4 25.5163 18.4 26.4C18.4 27.2837 19.1163 28 20 28C20.8837 28 21.6 27.2837 21.6 26.4C21.6 25.5163 20.8837 24.8 20 24.8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 20C34 27.732 27.732 34 20 34C12.268 34 6 27.732 6 20C6 12.268 12.268 6 20 6C27.732 6 34 12.268 34 20ZM20 31.6C26.4065 31.6 31.6 26.4065 31.6 20C31.6 13.5935 26.4065 8.4 20 8.4C13.5935 8.4 8.4 13.5935 8.4 20C8.4 26.4065 13.5935 31.6 20 31.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastError);
export default __webpack_public_path__ + "static/media/toast_error.8fa34928f0860da7281b2a1bed054684.svg";
export { ForwardRef as ReactComponent };